import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";

/**
 * Exclusive selector of the dashboard: Facturación / Cajas, and Con / Sin bonificaciones.
 *
 * Props:
 * - options:  the selectable options: { value, label, Icon }.
 * - value:    the currently selected option, or null when charts disagree (the global unit
 *             toggle renders no selection while units are mixed).
 * - onChange: called with the chosen option value.
 * - compact:  icon-only buttons with tooltips, for the tight chart-tile headers. The default
 *             renders the icon next to its label, for the toolbar-level toggles.
 */
function DashboardToggle({ options, value, onChange, compact = false }) {
    const handleChange = (_event, nextValue) => {
        if (nextValue != null) {
            onChange(nextValue);
        }
    };

    return (
        <ToggleButtonGroup value={value} exclusive size="small" onChange={handleChange}>
            {options.map(({ value: optionValue, label, Icon }) => (
                <Tooltip key={String(optionValue)} title={compact ? label : ""} disableHoverListener={!compact}>
                    <ToggleButton value={optionValue} sx={{ textTransform: "none", whiteSpace: "nowrap", gap: 0.5, px: compact ? 0.75 : 1.25 }}>
                        <Icon fontSize="small" />
                        {!compact && label}
                    </ToggleButton>
                </Tooltip>
            ))}
        </ToggleButtonGroup>
    );
}

export default DashboardToggle;
